// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"a53462af","453":"85f56a4c"}[chunkId] + ".chunk.js";
};